import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import QuizManager from './components/QuizManager';
import PlayQuiz from './components/PlayQuiz';
import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          {/* Home page - list quizzes and create new */}
          <Route path="/" element={<Home />} />
          
          {/* Quiz management page */}
          <Route path="/quiz/:quizId" element={<QuizManager />} />
          
          {/* Quiz play page */}
          <Route path="/play/:quizId" element={<PlayQuiz />} />
          
          {/* Catch-all redirect to home */}
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
